import { combineReducers } from 'redux';

import id from './id';
import dades from './dades';
import errors from './errors';
import peticioInserirEnCurs from './peticioInserirEnCurs';
import urlFotoAEliminar from './urlFotoAEliminar';

export default combineReducers({
    id,
    dades,
    errors,
    peticioInserirEnCurs,
    urlFotoAEliminar
});



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/index.js